import { cn } from '@/lib/utils';
import type { JawsCorrectionResponse } from '@/schema/JawsCorrection';
import useExportStore from '@export/hooks/useExportStore.ts';

interface Props {
  corrections: JawsCorrectionResponse[];
}

export function WeekSelector({ corrections }: Props) {
  const { activeCorrectionId, setActiveCorrectionId } = useExportStore();

  if (!corrections.length) {
    return (
      <section className="rounded-3xl border border-white/10 bg-black/30 p-4 text-white backdrop-blur">
        <p className="text-sm text-white/70">No corrections available yet.</p>
      </section>
    );
  }

  return (
    <section className="flex w-full flex-col gap-2 rounded-3xl border border-white/10 bg-black/30 p-4 text-white backdrop-blur">
      <span className="text-[11px] uppercase tracking-[0.3em] text-white/50">Treatment week</span>
      <div className="flex flex-wrap gap-2">
        {corrections.map((correction) => {
          const isActive = correction.id === activeCorrectionId;
          const totalAdjustments =
            correction.upperJaw.teethCorrection.length + correction.lowerJaw.teethCorrection.length;

          return (
            <button
              key={correction.id}
              type="button"
              onClick={() => setActiveCorrectionId(correction.id)}
              title={`${totalAdjustments} tooth adjustments`}
              className={cn(
                'min-w-9 rounded-xl border px-3 py-1.5 text-sm font-medium transition-all duration-200',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary',
                isActive
                  ? 'border-primary/70 bg-primary/20 text-white shadow shadow-primary/15'
                  : 'border-white/10 bg-white/5 text-white/70 hover:border-primary/40 hover:bg-primary/10 hover:text-white',
              )}
            >
              {correction.treatmentWeek}
            </button>
          );
        })}
      </div>
    </section>
  );
}
